import React, {useState} from "react";
import {useElements, useStripe} from "@stripe/react-stripe-js";
import AcCostItem from "../AcCostItem";
import {AC_PAGES, PAYMENT_TYPE, RESPONSE_TYPES} from "../../../../constants";
import {daysBetween, getPreferredACPaymentMethod, loadResponsePage} from "../../../../helpers/helpers";
import {ServerResponse} from "../../../../models/models";
import GenericItem from "../../../common/items/GenericItem";
import {SelectPaymentSection} from "../../../common/checkout/SelectPaymentSection";
import {NewPaymentSection} from "../../../common/checkout/NewPaymentSection";

const AcCheckoutPage = ({ appCenterData, product, price, payNow, role, expirationDate, paymentIntentId,
                            handleServerError, setServerResponse, setPage }) => {
    if (!appCenterData) {
        return <></>;
    }

    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));
    const { allPaymentMethods, devLevel, devLevelName, doNotRenew } = appCenterData;
    const selectedPlan = { value: devLevel };

    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(!payNow && allPaymentMethods.length === 0);
    const [selectedMethodId, setSelectedMethodId] = useState(getPreferredACPaymentMethod(allPaymentMethods)?.paymentMethodId || null);
    const [addNewMode, setAddNewMode] = useState(!payNow || allPaymentMethods.length === 0);

    const handleSavePaymentDataResult = (result) => {
        setLoading(false);
        if (result.status !== 200 && result.data?.error !== null && result.data?.error !== undefined) {
            console.error(result);
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data.error));
            return;
        } else if (result.status !== 200) {
            console.error(result);
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data || ''));
            return;
        }

        loadResponsePage('succeeded', setLoading, setServerResponse);
    };

    const getSubmitBtnText = () => {
        if (daysUntilExpired > 0 && !payNow) {
            return i18n.payments.attachPaymentMethod;
        } else if (doNotRenew) {
            return i18n.payments.oneTimePurchaseNow;
        }
        return i18n.payments.purchasePlan;
    }

    const submitBtnText = getSubmitBtnText();

    return (
        <div className={"row"} data-testid={'acCheckoutPage'}>
            <div className={"col-12"}>
                {
                    !payNow && (
                        <GenericItem details={i18n.payments.checkoutAttachingPaymentMethod}/>
                    )
                }

                <div className={'row'}>
                    <div className={'col-12'}>
                        <GenericItem title={`${i18n.payments.plan}: ${product.name}`}
                                     details={product.description}/>

                        <AcCostItem price={price}
                                    payNow={payNow}
                                    role={role}
                                    doNotRenew={doNotRenew}
                                    expirationDate={expirationDate}/>
                    </div>
                </div>

                <SelectPaymentSection type={PAYMENT_TYPE.AC}
                                      loading={loading}
                                      setLoading={setLoading}
                                      payNow={payNow}
                                      paymentIntentId={paymentIntentId}
                                      selectedPlan={selectedPlan}
                                      data={appCenterData}
                                      doNotRenew={doNotRenew}
                                      allPaymentMethods={allPaymentMethods}
                                      selectedMethodId={selectedMethodId}
                                      setSelectedMethodId={setSelectedMethodId}
                                      isEligibleForFreeTrial={false}
                                      addNewMode={addNewMode}
                                      setAddNewMode={setAddNewMode}
                                      onBack={() => setPage(AC_PAGES.PLAN_DETAILS)}
                                      handleSavePaymentDataResult={handleSavePaymentDataResult}
                                      submitBtnText={submitBtnText}/>

                <NewPaymentSection type={PAYMENT_TYPE.AC}
                                   stripe={stripe}
                                   elements={elements}
                                   doNotRenew={doNotRenew}
                                   loading={loading}
                                   setLoading={setLoading}
                                   payNow={payNow}
                                   paymentIntentId={paymentIntentId}
                                   selectedPlan={selectedPlan}
                                   handleSavePaymentDataResult={handleSavePaymentDataResult}
                                   submitBtnText={submitBtnText}
                                   isEligibleForFreeTrial={false}
                                   addNewMode={addNewMode}
                                   setAddNewMode={setAddNewMode}/>
            </div>
        </div>
    );
};

export default AcCheckoutPage;